import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { getAnalytics, logEvent } from "firebase/analytics";
import { getAI, getGenerativeModel, GoogleAIBackend, VertexAIBackend } from "firebase/ai";
import { addVersionToUrl } from '../utils/versionUtils';

// Firebase configuration
// You'll need to replace these values with your actual Firebase config
// const firebaseConfig = require('./firebaseConfig.json');
// const firebaseConfig = fetch(process.env.REACT_APP_API_URL + process.env.REACT_APP_FIREBASE_JSON);

export let firebaseObject: {
  app: any,
  auth: any,
  analytics: any,
  googleProvider: any,
  microsoftProvider: any,
  frontModel: any,
  logAnalyticsEvent: (eventName: string, eventParams?: { [key: string]: any }) => void
};

export const loadFirebaseConfig = async () => {
  const configPath = process.env.REACT_APP_FIREBASE_JSON_FILE || 'config/firebase.json';
  const configUrl = addVersionToUrl(process.env.REACT_APP_API_URL + "/" + configPath);
  console.log("Loading Firebase config from:", configUrl);
  return fetch(configUrl)
    .then(response => {
      if (!response.ok) throw new Error(`Firebase config request failed: ${response.status} ${response.statusText}`);
      return response.json();
    })
    .then(config => {
      firebaseObject = initializeFirebase(config);
    })
    .catch(error => {
      console.error("Error loading Firebase config:", error);
      // Re-throw so index.tsx's bootstrap shows its "Configuration Error / Reload"
      // screen. Swallowing here left firebaseObject undefined but still rendered
      // the app, so AuthProvider crashed on `firebaseObject.auth` (cryptic
      // "Cannot read properties of undefined (reading 'auth')") — e.g. whenever
      // the backend was briefly down at page load.
      throw error;
    });
}

const initializeFirebase = (config: Object) => {
  console.log("Firebase config:", config);
  // Initialize Firebase
  const app = initializeApp(config);

  // Initialize Firebase Authentication and get a reference to the service
  const auth = getAuth(app);
  const analytics = getAnalytics(app);
  const googleProvider = new GoogleAuthProvider();
  const microsoftProvider = new OAuthProvider('microsoft.com');

  const ai = getAI(app, {
    backend: new VertexAIBackend("global"),
    useLimitedUseAppCheckTokens: true // Enable limited-use App Check tokens for AI calls
  });

  const frontModel = getGenerativeModel(ai, { model: "gemini-3.8-flash" });

  const logAnalyticsEvent = (eventName: string, eventParams?: { [key: string]: any }) => {
    if (analytics) {
      logEvent(analytics, eventName, eventParams || {});
    }
  }

  console.log("Firebase initialized:", { app, auth, analytics, googleProvider, microsoftProvider, frontModel });
  return {
    app,
    auth,
    analytics,
    googleProvider,
    microsoftProvider,
    frontModel,
    logAnalyticsEvent
  }
}
